// extracted by mini-css-extract-plugin
module.exports = {"form":"Login_form__3bufY","link":"Login_link__Bm8wR"};